import PrefixEnum from '../prefixes'

export default Object.freeze({
    'www.yogabycathy.de': PrefixEnum.CATHY_HUMMELS,
    'yogabycathy.de': PrefixEnum.CATHY_HUMMELS,
    'www.yogabycathy.com': PrefixEnum.CATHY_HUMMELS,
    'yogabycathy.com': PrefixEnum.CATHY_HUMMELS,
})
